module.exports = "../images/avatar-placeholder.svg";